import { render } from "./Back.vue?vue&type=template&id=6e8ef6b6"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
script.render = render

export default script